import React, { useState } from 'react';
import axios from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import { Container, Draggable, DropResult } from 'react-smooth-dnd';
import { Badge, CircularProgress, Paper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import type { Image } from './ImageUploader';
import SimpleConfirm from './SimpleConfirm';

type PropTypes = {
    RemoveImage?: any;
    onDrag?: (images: Image[]) => void;
    images: Image[];
    setImages?: any;
}

const DragableImageList = (props: PropTypes) => {
    const [confirm, setconfirm] = useState(false);
    const [deletIndex, setdeletIndex] = useState(0);

    const { images, setImages } = props;

    function applyDrag(arr: Image[], dragResult: DropResult) {
        const { removedIndex, addedIndex, payload } = dragResult;
        if (removedIndex === null && addedIndex === null) return arr;

        const result = [...arr];
        let itemToAdd = payload;

        if (removedIndex !== null) {
            itemToAdd = result.splice(removedIndex, 1)[0];
        }

        if (addedIndex !== null) {
            result.splice(addedIndex, 0, itemToAdd);
        }

        if(props.onDrag) props.onDrag(result);

        return result;
    };

    function onDelete(index: number) {
        setconfirm(true);
        setdeletIndex(index);
    }

    function RemoveAtIndex(i: number) {
        props?.RemoveImage(images[i].url);

        const newImages = [...images];
        newImages.splice(i, 1);
        setImages(newImages);
    }

    return (
        <div>
            <Paper className="p-5">
                <Container orientation="horizontal" lockAxis="x" onDrop={(e) => setImages(applyDrag(images, e))}>
                    {images.map((image, index) => {
                        const element = (
                            <div className='m-2'>
                                <div
                                    className='hover:cursor-pointer relative top-[0.625rem] left-[-0.625rem] rounded-full text-black bg-orange-main text-black !h-5 !w-5 flex justify-center items-center text-center z-10'
                                    onClick={() => onDelete(index)}
                                >
                                    <CloseIcon className='invert scale-75' />
                                </div>
                                <div className='relative'>
                                    <img
                                        draggable={false}
                                        src={image.url}
                                        className={`object-cover rounded-sm pointer-events-none aspect-square h-24 pointer-events-auto ${image.loading ? 'brightness-50' : ''}`}
                                    />
                                    {image.loading && <div className='absolute top-0 w-full h-full flex justify-center items-center' ><CircularProgress className='' /></div>}
                                </div>
                            </div>
                        );

                        return <Draggable key={image.url}>{element}</Draggable>
                        // return element
                    })}
                </Container>
            </Paper>

            <SimpleConfirm
                setOpen={setconfirm}
                action={() => RemoveAtIndex(deletIndex)}
                open={confirm}
                title={'Delete image?'}
                content={`This can't be undone.`}
            />
        </div>
    );
}


export default DragableImageList;